'use strict';

require('waypoints/lib/noframework.waypoints.js');

function init() {
    var trigger = document.querySelector(".js-trigger");
    if (!trigger) {
        return false;
    }
    var productionOverlay = document.querySelector(".js-production-overlay");
    new Waypoint({
        element: trigger,
        handler: function(direction) {
            if (direction === 'down') {
                productionOverlay.classList.add("is-active");
            } else {
                productionOverlay.classList.remove("is-active");
            }
        },
        offset: 100
    })
}

module.exports = {
    init: init
};




// WEBPACK FOOTER //
// ./modules/productionOverlay.js